<template>
  <v-container fluid>
    <page-header showBackButton></page-header>

    <v-card class="mb-4">
      <v-card-text>
        <v-form ref="basicForm" @submit.prevent>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" lg="4" class="pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="4" class="pr-0">
                  <form-select :fieldValue.sync="formData.zone" :options="$phoneCodeOptions" required />
                </v-col>
                <v-col cols="8">
                  <form-input
                    label="phone"
                    :fieldValue.sync="formData.phone"
                    type="tel"
                    :customRules="[v => !v || $validate.isMobile(v, formData.zone, false)]"
                    required
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-select label="knownFrom" :fieldValue.sync="formData.known_from" :options="$knowFromOptions" />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-select label="status" :fieldValue.sync="formData.status" :options="$statusOptions" required />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      depressed
      elevation="0"
      class="ml-2 mb-4"
      color="primary"
      type="button"
      @click="save()"
      :loading="$store.getters.isLoading"
      >{{ $t('save') }}</v-btn
    >
  </v-container>
</template>

<script>
import FormSelect from '@/components/form/FormSelect.vue'
import FormInput from '@/components/form/FormInput.vue'
export default {
  name: 'CreateUser',
  components: {
    FormSelect,
    FormInput,
  },
  data: vm => ({
    formData: {
      create_date: '',
      zone: '852',
      phone: '',
      known_from: '',
      status: 'active',
      verify: false,
    },
  }),
  methods: {
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const valid = await this.$refs['basicForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true)

      const payload = {
        zone: this.formData.zone,
        phone: this.formData.phone,
        known_from: this.formData.known_from ? [this.formData.known_from] : [],
        verify: true,
        status: this.formData.status,
      }
      try {
        await this.$Fetcher.NewUser(payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          type: 'success',
          message: 'message.saveSuccess',
          redirect: 'UserList',
        })
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setAlert', {
          title: 'message.saveFail',
          message: err,
          type: 'error',
        })
      }
    },
  },

  async mounted() {
    this.$store.dispatch('setInitLoading', false)
  },
}
</script>
